import fetchIntercept from 'fetch-intercept';
export default {
  id: 'molten.FetchInterceptInit',
  sort: 100,
  init: molten => {
    fetchIntercept.register({
      responseError(err) {
        if (err.status === 503 && !window.location.pathname.startsWith('/maintenance')) {
          window.location.href = '/maintenance';
        }
        return Promise.reject(err);
      }
    });
  }
};